/*
 * @Descripttion:
 * @version:
 * @Author: jianghongtao
 * @Date: 2023-04-11 09:51:22
 */
import { getLanguageResource } from '../../api/user'

const state = {
  languagePackage: {}
}

const mutations = {
  // SET_LANGUAGE:(state,languagePackage) => {
  // state.languagePackage = languagePackage
  // },
}

const actions = {
  // 获取多语言
  getLanguage({ commit }, query = { packageName: 'giga', languageCode: '' }) {
    return new Promise((resolve, reject) => {
      getLanguageResource(query).then(response => {
        const { data } = response
        // if (data) {
        // commit('SET_LANGUAGE', data.filedMap)
        // localStorage.setItem('langPackage', JSON.stringify(data.filedMap))
        // }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
